import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { MdClose } from 'react-icons/md';
import { SpinnerLoader } from '../loaders';
import classes from './CustomReactModal.module.scss';

const CustomReactModal = (props) => {
    const {
        children,
        id,
        position,
        testId,
        contentLabel,
        isOpen,
        onRequestClose,
        onAfterOpen,
        isLoading,
        contentStyles,
    } = props;

    const positionObject = {
        top: position === 'top' ? '2rem' : '50%',
        transform: position === 'top' ? 'translateX(-50%)' : 'translate(-50%, -50%)',
    };

    const customStyles = {
        overlay: {
            backgroundColor: 'rgba(51, 51, 51, 0.28)',
        },
        content: {
            ...positionObject,
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            borderRadius: 'var(--border-radius-xxl)',
            paddingTop: '1rem',
            maxWidth: '94%',
            ...contentStyles,
        },
    };

    Modal.setAppElement('#root');

    const renderChildren = () => {
        if (isLoading) {
            return (
                <div className={classes.Loader}>
                    <SpinnerLoader size="large" trackColor="#ccc" spinnerColor="#5667ff" />
                </div>
            );
        }
        return children;
    };
    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={onRequestClose}
            style={customStyles}
            contentLabel={contentLabel}
            id={id}
            testId={testId}
            role="dialog"
        >
            <div className={classes.CustomReactModal}>
                <button
                    className={classes.CustomReactModal__Close}
                    type="button"
                    onClick={onRequestClose}
                    title="close"
                >
                    <MdClose />
                </button>
                {renderChildren()}
            </div>
        </Modal>
    );
};

CustomReactModal.propTypes = {
    children: PropTypes.element,
    id: PropTypes.string,
    position: PropTypes.string,
    testId: PropTypes.string,
    contentLabel: PropTypes.string,
    isOpen: PropTypes.bool,
    onRequestClose: PropTypes.func,
    onAfterOpen: PropTypes.func,
    isLoading: PropTypes.bool,
    contentStyles: PropTypes.object,
};

export default CustomReactModal;
